import { mapToolTypeLists, ToolTypeList } from "./ToolTypeList";

export interface ToolListData {
    id?: number;
    category_name?: string;
    path?: string | null;
    status?: 1 | 0;
    tool_type_count?: number;
    tool_type_list?: ToolTypeList[];
}

// to single object maping
export const mapToolListData = (data:any): ToolListData => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: ToolListData ={
        id: data.id,
        category_name: data.category_name,
        path: data.path,
        status: data.status,
        tool_type_count: data.tool_type_count,
        tool_type_list:mapToolTypeLists(data.tool_type_list)
    }
    return res;
}

// maping list objects
export const mapToolListDatas = (data:any[]): ToolListData[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapToolListData);
}